import React, { useState, useEffect } from 'react';
import styles from './UserHome.module.css';

const OverallStats = ({ overallData, isGroups }) => {
  if (isGroups) {
    return (
      <div className={styles.overall_container}>
        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            TOTAL GROUPS
          </div>
          {overallData.total}
        </div>

        <div style={{ height: "56px", width: "1px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            NEW GROUPS (LAST 30 DAYS)
          </div>
          {overallData.last_thirty_signups}
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.overall_container}>
        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            TOTAL USERS
          </div>
          {overallData.total}
        </div>

        <div style={{ height: "56px", width: "1px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            ACTIVE (LAST 30 DAYS)
          </div>
          {overallData.last_thirty_active}
        </div>

        <div style={{ height: "56px", width: "1px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            SIGNUPS (LAST 30 DAYS)
          </div>
          {overallData.last_thirty_signups}
        </div>

        <div style={{ height: "56px", width: "1px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            TOTAL ENTRIES
          </div>
          {overallData.total_entries}
        </div>

        <div style={{ height: "56px", width: "0.5px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            ENTRIES (LAST 30 DAYS)
          </div>
          {overallData.last_thirty_entries}
        </div>

        <div style={{ height: "56px", width: "1px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            TOTAL REVIEWS
          </div>
          {overallData.total_reviews}
        </div>

        <div style={{ height: "56px", width: "0.5px", backgroundColor: "#000" }} />

        <div className={styles.stat_container}>
          <div style={{ fontSize: "9px", marginBotto: "6px", fontWeight: 'bold', color: '#000'}}>
            REVIEWS (LAST 30 DAYS)
          </div>
          {overallData.last_thirty_reviews}
        </div>


      </div>
    );
  }
};


export default OverallStats;
